/**
 * 最近一次生成的 4 怪（用于系统对战）
 * 与 zoo（被查看并入园的怪）独立 —— 这是"刚生成"的怪
 */

import type { MonsterDesc } from "../shared/types";
import type { Screen2Combo } from "./screens/screen2";

const KEY = "lastGeneration";
const MAX = 4;

export interface LastGenEntry {
  monster: MonsterDesc;
  combo: Screen2Combo;
}

function read(): LastGenEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.slice(0, MAX);
  } catch {
    return [];
  }
}

function write(entries: LastGenEntry[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(entries.slice(0, MAX)));
  } catch {
    /* ignore */
  }
}

export function getLastGeneration(): LastGenEntry[] {
  return read();
}

export function saveLastGeneration(monsters: MonsterDesc[], combos: Screen2Combo[]): void {
  if (monsters.length === 0) return;
  const list: LastGenEntry[] = monsters.map((m, i) => ({
    monster: m,
    combo: combos[i] ?? {
      bodyType: "abstract" as const,
      paletteName: "PinkPop",
      variant: 0 as const,
    },
  }));
  write(list);
}

export function clearLastGeneration(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
